import {CloseOutlined, InfoCircleOutlined} from '@ant-design/icons';
import {CountdownTimer} from '@countdown-timer';
import {BottomSheet, Button, IconButton, OtpInput} from '@ds/components';
import {toast} from '@Toast';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch} from 'store';
import {confirmVendorPro} from 'store/slices/vendor-pro/thunk';

import {OTP_COUNTDOWN_SECONDS, PRO_ROUTES} from '../../../constants';

type ProOtpSheetProps = {
  vendorId: string | number;
  isOpen: boolean;
  onClose: () => void;
  onSubmitFormClick: () => Promise<void>;
};

const ProOtpSheet: React.FC<ProOtpSheetProps> = ({
  vendorId,
  isOpen,
  onClose,
  onSubmitFormClick
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [countDown, setCountDown] = useState(OTP_COUNTDOWN_SECONDS);

  useEffect(() => {
    if (isOpen) {
      setCountDown(OTP_COUNTDOWN_SECONDS);
    }
  }, [isOpen]);

  const confirmPayment = async () => {
    if (otp.length !== 5) {
      toast('لطفا کد پیامک شده را وارد کنید');
      return;
    }

    try {
      const response = (await dispatch(
        confirmVendorPro({
          vendor_id: Number(vendorId),
          code: otp
        })
      ).unwrap()) as {data?: Record<string, unknown>; state?: string; start_date?: string};

      navigate(PRO_ROUTES.paymentSuccess, {
        state: {...(response.data ?? response)}
      });
    } catch {
      toast('کد اشتباه است');
    }
  };

  const resendOtp = async () => {
    try {
      await onSubmitFormClick();
      setCountDown(OTP_COUNTDOWN_SECONDS);
    } catch {
      toast('مشکلی پیش آمده. دوباره تلاش کنید!');
    }
  };

  return (
    <BottomSheet
      show={isOpen}
      onClose={onClose}
      header={
        <div className="flex items-center gap-2 px-2 pt-2">
          <IconButton aria-label="بستن" size="md" onClick={onClose}>
            <CloseOutlined aria-hidden />
          </IconButton>
          <h2 className="text-subtitle-md text-neutral-fg">دریافت رمز یکبار مصرف</h2>
        </div>
      }
      footer={
        <div className="flex justify-end border-t border-gray-04 p-2.5">
          <Button onClick={() => void confirmPayment()}>تایید پرداخت</Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 p-4">
        <p className="text-body-sm text-neutral-fg">
          برای تایید پرداخت، رمز یک‌بارمصرف ارسال شده را وارد کنید.
        </p>
        <OtpInput length={5} value={otp} onChange={setOtp} />
        <div className="flex items-center justify-center gap-2.5 text-body-sm text-gray-08">
          {countDown > 0 ? (
            <>
              <span>درخواست دوباره رمز تا</span>
              <CountdownTimer initialCounter={countDown} setCountDown={setCountDown} />
            </>
          ) : (
            <>
              <span>کد را دریافت نکردید؟</span>
              <Button
                className="px-0!"
                variant="link"
                color="primary"
                size="sm"
                onClick={() => void resendOtp()}
              >
                ارسال دوباره کد
              </Button>
            </>
          )}
        </div>
        <div className="flex gap-2.5 rounded-xl bg-blue-mist p-4 text-body-sm text-neutral-fg">
          <InfoCircleOutlined aria-hidden className="mt-1 shrink-0 text-body-lg" />
          <p>مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.</p>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ProOtpSheet;
